export const BUSINESS = {
  name: "Digital Hights",
  phone: "8390488910",
  phoneIntl: "+918390488910",
  email: "digitalhights2025@gmail.com",
  location: "Pune, Maharashtra",
  whatsapp: "https://wa.link/jjuq3h",
  tagline: "Real Estate Digital Marketing Agency in Pune",
};

export const IMAGES = {
  heroBalcony: "https://customer-assets.emergentagent.com/job_pune-marketing-1/artifacts/xcn9lmd9_1_I0xFGbIUj_zTzVwgfjEMGg.jpg",
  heroTowers: "https://customer-assets.emergentagent.com/job_pune-marketing-1/artifacts/bm2c7ar7_3_5.jpg",
  industryRealEstate: "https://customer-assets.emergentagent.com/job_pune-marketing-1/artifacts/qsln6v6a_raheja-stellar-home.jpg",
  industryLocal: "https://customer-assets.emergentagent.com/job_pune-marketing-1/artifacts/2n83s0eo_facade-2000x1322.jpg",
  industryHealthcare: "https://images.unsplash.com/photo-1538108149393-fbbd81895907?auto=format&fit=crop&w=1600&q=80",
  industryEducation: "https://images.unsplash.com/photo-1523050854058-8df90110c9f1?auto=format&fit=crop&w=1600&q=80",
};
